// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__gMF2Q","fileBtn":"File_fileBtn__1Guli","closeBtn":"File_closeBtn__3HRz9","fileSelected":"File_fileSelected__2c4xB","disabled":"File_disabled__2oM7L"};